import { useState, useEffect } from "react";
import React from "react";
import { Col, Container, Row, Card, CardBody, Table, Alert } from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import { get, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import avatar from "../../../assets/images/personPlaceholder.png";
import "react-datepicker/dist/react-datepicker.css";
import Placeholder from "../../../assets/images/Placeholder.gif";
const ListUser = () => {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(null);
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.user}?filter=active&limit=5`);

      setUsersData(
        Array.isArray(response.data?.data) ? response.data.data : []
      );
    } catch (err) {
      setError("Failed to load users. Please try again later.");
      setUsersData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage, searchTerm);
  }, [currentPage, searchTerm]);

  return (
    <Card className="rounded-4 mb-2 hide-scrollbar ">
      <CardBody>
        <div className="float-end">
          <span className="ff-sora font-size-16 fw-bold secondary-black">
            <Link
              to="/list-users"
              className="ff-sora font-size-16 fw-bold secondary-black"
            >
              View All
            </Link>
          </span>
        </div>
        <span className="ff-sora font-size-16 fw-normal primary-black">
          Users
        </span>
        <div
          className="table-responsive hide-scrollbar"
          style={{ height: "350px" }}
        >
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div
                className="spinner-border"
                style={{
                  width: "3rem",
                  height: "3rem",
                  color: "#3BABA6",
                }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <Alert
              color="danger"
              className="text-center ff-sora font-size-14 secondary-black fw-normal"
            >
              {error}
            </Alert>
          ) : usersData.length === 0 ? (
            <>
              <tr>
                <td
                  colSpan="3"
                  className="text-center ff-sora font-size-16 fw-normal"
                >
                  <img
                    src={Placeholder}
                    alt="Placeholder"
                    className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                  />
                </td>
              </tr>
              <tr>
                <td
                  colSpan="3"
                  className="text-center border-0 ff-sora font-size-16 fw-normal"
                >
                  No User Found!
                </td>
              </tr>
            </>
          ) : (
            <Table className="table-borderless table-centered table-nowrap">
              <thead>
                <tr
                  className="ff-sora font-size-14 fw-bold primary-black"
                  style={{ lineHeight: "16.8px" }}
                >
                  <th>Id</th>
                  <th>User</th>
                  <th>Account Status</th>
                </tr>
              </thead>
              <tbody>
                {usersData.map((user, index) => (
                  <tr key={user.id + index}>
                    <td className="ff-sora">{index + 1}</td>
                    <td>
                      <div className="d-flex ff-sora align-items-center">
                        <img
                          src={
                            user.additionalInfo?.profileImage
                              ? `${process.env.REACT_APP_IMG_URL}${user.additionalInfo.profileImage}`
                              : avatar
                          }
                          alt={`${user.firstName || ""} ${
                            user.lastName || ""
                          } avatar`}
                          className="rounded-circle object-fit-cover me-2 p-0 m-0 "
                          width="25"
                          height="25"
                          onError={(e) => {
                            e.target.src = avatar;
                          }}
                        />
                        <div>
                          <h6 className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                            {user.firstName && user.lastName
                              ? `${user.firstName} ${user.lastName}`
                              : "N/A"}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        className={`badge font-size-14 fw-normal py-2 px-2 ff-sora ${
                          user.emailVerified
                            ? "bg-soft-success text-success"
                            : "bg-warning-subtle text-warning"
                        }`}
                      >
                        {user.emailVerified ? "Verified" : "Un-Verified"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default ListUser;
